import { combineReducers } from 'redux';
import pumpReducer from './pump/reducer';
import { masterDataPumpingStationReducer } from './pumpingStation';
import masterDataGeoServerReducer from './geoserver/reducer';
import masterDataValueAddedTaxReducer from './valueAddedTax/reducer';

export const masterDataReducer = combineReducers({
    pump: pumpReducer,
    pumpingStation: masterDataPumpingStationReducer,
    geoserver: masterDataGeoServerReducer,
    valueAddedTax: masterDataValueAddedTaxReducer,
});